import { render, staticRenderFns } from "./BroadcasterItem.vue?vue&type=template&id=30012f82&scoped=true"
import script from "./BroadcasterItem.vue?vue&type=script&lang=js"
export * from "./BroadcasterItem.vue?vue&type=script&lang=js"
import style0 from "./BroadcasterItem.vue?vue&type=style&index=0&id=30012f82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30012f82",
  null
  
)

export default component.exports